'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _Button = require('components/Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _CheckedCount = require('components/CheckedCount/CheckedCount');

var _CheckedCount2 = _interopRequireDefault(_CheckedCount);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _songs = require('redux/modules/songs');

var songsActions = _interopRequireWildcard(_songs);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./SongsSelectPopup.scss');

var SongsSelectPopupFooter = (_dec = (0, _reactRedux.connect)(null, (0, _extends3.default)({}, songsActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(SongsSelectPopupFooter, _Component);

  function SongsSelectPopupFooter() {
    (0, _classCallCheck3.default)(this, SongsSelectPopupFooter);
    return (0, _possibleConstructorReturn3.default)(this, (SongsSelectPopupFooter.__proto__ || (0, _getPrototypeOf2.default)(SongsSelectPopupFooter)).apply(this, arguments));
  }

  (0, _createClass3.default)(SongsSelectPopupFooter, [{
    key: 'clearSelection',
    value: function clearSelection() {
      var updateCheckedSongs = this.props.updateCheckedSongs;

      updateCheckedSongs({});
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          checkedCount = _props.checkedCount,
          onSave = _props.onSave;


      return _react2.default.createElement(
        'div',
        { className: styles.bottomContainer },
        _react2.default.createElement(_CheckedCount2.default, { checkedCount: checkedCount, onClear: this.clearSelection }),
        _react2.default.createElement(
          'div',
          { className: styles.buttonContainer },
          _react2.default.createElement(
            _Button2.default,
            { className: 'btn-primary', onClick: onSave },
            t('Save')
          )
        )
      );
    }
  }]);
  return SongsSelectPopupFooter;
}(_react.Component), _class3.propTypes = {
  checkedCount: _propTypes2.default.number,
  onSave: _propTypes2.default.func,
  t: _propTypes2.default.func,
  updateCheckedSongs: _propTypes2.default.func
}, _class3.defaultProps = {
  checkedCount: 0,
  onSave: _noop3.default,
  updateCheckedSongs: _noop3.default
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'clearSelection', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'clearSelection'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = SongsSelectPopupFooter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SongsSelectPopup/SongsSelectPopupFooter.js
// module id = 2103
// module chunks = 1